<template>
  <div>
    <v-data-table
      :headers="headers" :items="users"
      :loading="loading"
      :pagination.sync="filter"
      :total-items="pagination.total"
      :rows-per-page-items="[pagination.perPage]"
      select-all selected-key="id"
      v-model="selectedItems"
      :no-data-text="$t('user.table.noDataText')"
      :no-results-text="$t('user.table.noResultsText')"
      :rows-per-page-text="$t('user.table.rowsPerPageText')"
      hide-actions>
      <template slot="items" scope="props">
        <td><v-checkbox hide-details v-model="props.selected"></v-checkbox></td>
        <td><router-link :to="{ name: 'User', params: { id: props.item.id, tab: 'profile' } }">{{ props.item.nickname }}</router-link></td>
        <td>{{ props.item.last_name }}</td>
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.email }}</td>
        <td class="text-xs-right"><price :value="props.item.stats.purchases.total"></price></td>
        <td class="text-xs-right"><minute :value="props.item.phone_seconds_available"></minute></td>
        <td class="text-xs-right"><date :value="props.item.created_at"></date></td>
        <td class="text-xs-right"><date :value="props.item.current_sign_in_at"></date></td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-3 pb-3">
      <v-pagination
        v-if="filter"
        :disabled="loading"
        :value="filter.page"
        @input="value => changePage(value)"
        :length="Math.ceil(pagination.total / pagination.perPage)">
      </v-pagination>
    </div>
  </div>
</template>

<script>
  import pagination from '@/mixins/pagination'
  import { Date, Price, Minute } from '@/components/formatters'
  export default {
    components: {
      Date,
      Price,
      Minute
    },
    mixins: [
      pagination('skiliko/users')
    ],
    props: {
      selected: {
        type: Array,
        default: () => []
      },
      descending: {
        type: Boolean,
        default: true
      },
      sortBy: {
        type: String,
        default: null
      },
      dataFilter: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        selectedItems: this.selected,
        filter: {
          page: this.page,
          descending: this.descending,
          sortBy: this.sortBy,
          ...this.dataFilter
        }
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('user.table.header.nickname'), left: true, sortable: true, value: 'nickname' },
          { text: this.$t('user.table.header.last_name'), left: true, sortable: true, value: 'last_name' },
          { text: this.$t('user.table.header.first_name'), left: true, sortable: true, value: 'first_name' },
          { text: this.$t('user.table.header.email'), left: true, sortable: true, value: 'email' },
          { text: this.$t('user.table.header.payed_purchases_sum'), left: false, sortable: true, value: 'payed_purchases_sum' },
          { text: this.$t('user.table.header.phone_seconds_available'), left: false, sortable: true, value: 'phone_seconds_available' },
          { text: this.$t('user.table.header.created_at'), left: false, sortable: true, value: 'created_at' },
          { text: this.$t('user.table.header.current_sign_in_at'), left: false, sortable: true, value: 'current_sign_in_at' }
        ]
      }
    },
    watch: {
      dataFilter () {
        const filterWithoutSearch = Object.keys(this.filter)
          .filter(x => !x.startsWith('q['))
          .reduce((acc, x) => ({ ...acc, [x]: this.filter[x] }), {})
        this.filter = { ...filterWithoutSearch, ...this.dataFilter }
      },
      selectedItems () { this.$emit('input', this.selectedItems) }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Table.vue